export const SubscriptionAssignmentErrorTypes = {
    UserAccountAlreadyExist: "CannotGiveAccountToExistingUser",
    UserAlreadyHasSubscriptionOfTypeFromOrganization: "UserAlreadyHasSubscriptionOfTypeFromOrganization",
    NoAvailableSubscriptionForType: "NoAvailableSubscriptionForType",
    FailedToAssignSubscriptionToUser: "FailedToAssignSubscriptionToUser"
};
